// @flow
import classnames from 'classnames';

import css from '@styles/catalogFilters';

import type { Node } from 'react';

type TProps = {
  children: Node,
  className?: string,
  show: boolean
};

function FilterCheckItems({ children, className, show }: TProps) {
  return show ? (
    <ul className={classnames(css.contentDropdown, className)}>{children}</ul>
  ) : null;
}

export default FilterCheckItems;
